import {Construtor} from './construtor';
import {Processo} from './processo';

export class ProcessoCliente implements Construtor<ProcessoCliente> {

  public idProcessoCliente: number;
  public idCliente: number;
  public processo: Processo;
  public setoresVinculados: number;
  public pontosFisicosVinculados: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    this.processo = new Processo();
    if (object !== undefined) {
      if (object instanceof (ProcessoCliente)) {
        this.copyObject(object);
      } else if (object instanceof Processo) {
        this.processo = new Processo(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(processoCliente: any): void {
    this.idProcessoCliente = processoCliente.idProcessoCliente;
	this.processo = processoCliente.processo;
	this.setoresVinculados = processoCliente.setoresVinculados;
	this.pontosFisicosVinculados = processoCliente.pontosFisicosVinculados;
    this.idCliente = processoCliente.idCliente;
  }

  copyObject(processoCliente: ProcessoCliente): void {
    this.idProcessoCliente = processoCliente.idProcessoCliente;
    this.processo = processoCliente.processo;
	this.setoresVinculados = processoCliente.setoresVinculados;
	this.pontosFisicosVinculados = processoCliente.pontosFisicosVinculados;
    this.idCliente = processoCliente.idCliente;
  }

  modeloCompleto(): boolean {
    return this.processo !== undefined && this.idCliente !== undefined;
  }

  getNewInstance(object?: any): ProcessoCliente {
    return new ProcessoCliente(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/processo-cliente.ts